import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { merge } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { accountRegisterAdapterActions } from 'src/app/pages/account-register/state/account-register.actions';
import { accountActiveCallsRegisterAdapterActions } from 'src/app/pages/active-calls/state/account-active-calls/account-active-calls.actions';
import { accountCallHistoryRegisterAdapterActions } from 'src/app/pages/active-calls/state/account-call-history/account-call-history.actions';
import { systemActiveCallsRegisterAdapterActions } from 'src/app/pages/active-calls/state/system-active-calls/system-active-calls.actions';
import { allowIpFailure } from 'src/app/pages/banned-provisioning-ip-register/state/banned-provisioning-ip-register.actions';
import { blockedPhoneNumberRegisterAdapterActions } from 'src/app/pages/blocked-phone-number-register-component/state/blocked-phone-number-register.actions';
import {
   callLogsRegisterAdapterActions,
   deleteCallRecordingFailure,
} from 'src/app/pages/call-logs-register/state/call-logs-register.actions';
import * as DeviceRegisterActions from 'src/app/pages/device-register/state/device-register.actions';
import { deviceRegisterAdapterActions } from 'src/app/pages/device-register/state/device-register.actions';
import { extensionRegisterAdapterActions } from 'src/app/pages/extension-register/state/extension-register.actions';
import * as MailboxMessageActions from 'src/app/pages/mailbox-messages/state/mailbox-message-detail.actions';
import { mailboxRegisterAdapterActions } from 'src/app/pages/mailbox-register/state/mailbox-register.actions';
import { phoneNumberRegisterAdapterActions } from 'src/app/pages/phone-number-register/state/phone-number-register.actions';
import { phoneRegisterAdapterActions } from 'src/app/pages/phones/phone-register/state/phone-register.actions';
import { presenceContactRegisterAdapterActions } from 'src/app/pages/presence-contact-register/state/presence-contact-register.actions';
import { promptRegisterAdapterActions } from 'src/app/pages/prompt-register/state/prompt-register.actions';
import * as queueHistoryActions from 'src/app/pages/queue-history-register/state/queue-history-register.actions';
import { logRegisterAdapterActions } from 'src/app/pages/system-log-register/state/system-log-register.actions';
import { submitUserPasswordResetRequestFailure } from 'src/app/pages/user-password-reset-request/state/user-password-reset-request.actions';
import { userPasswordResetFailure } from 'src/app/pages/user-password-reset/state/user-password-reset.actions';
import { userRegisterAdapterActions } from 'src/app/pages/user-register/state/user-register.actions';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DialogSize } from '../../confirmation-dialog/enumerations/dialog-size.enum';
import { ConfirmationDialogType } from '../../confirmation-dialog/models/confirmation-dialog.config';
import { processErrorMessage } from '../error-processor';
import * as AccountDetailActions from './../../../pages/account-details/state/account-detail.actions';
import * as AccountVerificationActions from './../../../pages/account-verification/state/account-verification.actions';
import * as AddAccountActions from './../../../pages/add-account/state/add-account.actions';
import * as AddBlockedPhoneNumberActions from './../../../pages/add-blocked-phone-number/state/add-blocked-phone-number.actions';
import * as AddDeviceActions from './../../../pages/add-devices/state/add-device.actions';
import * as AddExtensionActions from './../../../pages/add-extension/state/add-extension.actions';
import * as AddLocationActions from './../../../pages/add-location/state/add-location.actions';
import * as AddPhoneNumberActions from './../../../pages/add-phone-number/state/add-phone-number.actions';
import * as AddHardphoneActions from './../../../pages/add-phone-to-device/state/add-hardphone.actions';
import * as AddPhoneActions from './../../../pages/add-phone/state/add-phone.actions';
import * as AddPromptActions from './../../../pages/add-prompt/state/add-prompt.actions';
import * as AddUserActions from './../../../pages/add-user/state/add-user.actions';
import * as DashboardActions from './../../../pages/dashboard/state/dashboard.actions';
import * as DepartmentDetailActions from './../../../pages/department-details/state/department-detail.actions';
import * as DeviceDetailActions from './../../../pages/device-details/state/device-detail.actions';
import * as ExtensionDetailActions from './../../../pages/extension-details/state/extension-detail.actions';
import * as LocationDetailActions from './../../../pages/location-details/state/location-detail.actions';
import * as MailboxDetailActions from './../../../pages/mailbox-details/state/mailbox-detail.actions';
import * as PhoneNumberDetailActions from './../../../pages/phone-number-details/state/phone-number-detail.actions';
import * as ExtensionPhoneRegisterActions from './../../../pages/phones/extension-phone-register/state/extension-phone-register.actions';
import * as PromptDetailActions from './../../../pages/prompt-details/state/prompt-detail.actions';
import * as RoleDetailActions from './../../../pages/role-details/state/role-detail.actions';
import * as ScheduleDetailActions from './../../../pages/schedule-details/state/schedule-detail.actions';
import * as UserDetailActions from './../../../pages/user-details/state/user-detail.actions';
@Injectable()
export class ErrorMessageEffects {
   handleError$ = createEffect(
      () => {
         return merge(
            this.actions$.pipe(
               ofType(
                  AddPhoneActions.savePhoneFailure,
                  AddAccountActions.createAccountFailure,
                  AddDeviceActions.createDeviceFailure,
                  AddDeviceActions.createDeviceAndAddAnotherFailure,
                  AccountDetailActions.loadAccountDetailsFailure,
                  AddExtensionActions.createExtensionFailure,
                  AddBlockedPhoneNumberActions.createBlockedPhoneNumberFailure,
                  DashboardActions.addDashboardFailure,
                  AddBlockedPhoneNumberActions.createBlockedPhoneNumberAndAddAnotherFailure,
                  AddPhoneNumberActions.createPhoneNumberFailure,
                  AddPhoneNumberActions.createPhoneNumberAndAddAnotherFailure,
                  AddPhoneNumberActions.createPhoneNumberAndAddAnotherFailure,
                  AddHardphoneActions.addHardphoneFailure,
                  AddPromptActions.createPromptFailure,
                  AddLocationActions.createLocationFailure,
                  AddUserActions.createUserFailure,
                  AccountDetailActions.saveAccountDetailFailure,
                  ExtensionDetailActions.saveExtensionDetailFailure,
                  ExtensionDetailActions.deleteExtensionFailure,
                  ExtensionDetailActions.changeSipUserPasswordFailure,
                  PhoneNumberDetailActions.loadPhoneNumberDetailFailure,
                  PhoneNumberDetailActions.savePhoneNumberDetailFailure,
                  PhoneNumberDetailActions.releasePhoneNumberDetailFailure,
                  ExtensionPhoneRegisterActions.deleteExtensionPhoneFailure,
                  PromptDetailActions.savePromptDetailFailure,
                  PromptDetailActions.deletePromptFailure,
                  PromptDetailActions.loadPromptDetailFailure,
                  UserDetailActions.saveUserDetailFailure,
                  UserDetailActions.deleteUserFailure,
                  UserDetailActions.loadUserDetailsFailure,
                  AccountVerificationActions.savePasswordFailure,
                  AccountVerificationActions.activateAccountFailure,
                  AccountVerificationActions.retrievedCanAccountBeFinalizedFailure,
                  DeviceDetailActions.loadDeviceDetailFailure,
                  DeviceDetailActions.deleteDeviceFailure,
                  DeviceDetailActions.saveDeviceDetailFailure,
                  DeviceDetailActions.releaseDeviceDetailFailure,
                  DeviceDetailActions.changeSipUserPasswordFailure,
                  DeviceDetailActions.releaseDeviceDetailFailure,
                  DeviceDetailActions.releaseDeviceToAccountFailure,
                  ScheduleDetailActions.deleteScheduleFailure,
                  ScheduleDetailActions.deleteScheduleDetailFailure,
                  ScheduleDetailActions.loadScheduleDetailFailure,
                  ScheduleDetailActions.saveScheduleDetailFailure,
                  DepartmentDetailActions.deleteDepartmentFailure,
                  DepartmentDetailActions.deleteDepartmentDetailFailure,
                  DepartmentDetailActions.loadDepartmentDetailFailure,
                  DepartmentDetailActions.saveDepartmentDetailFailure,
                  MailboxDetailActions.loadMailboxDetailFailure,
                  MailboxDetailActions.saveMailboxDetailFailure,
                  RoleDetailActions.deleteRoleFailure,
                  RoleDetailActions.saveRoleDetailFailure,
                  RoleDetailActions.loadRoleDetailsFailure,
                  userRegisterAdapterActions.loadFailure,
                  userRegisterAdapterActions.loadPageFailure,
                  phoneRegisterAdapterActions.loadFailure,
                  phoneRegisterAdapterActions.loadPageFailure,
                  DeviceRegisterActions.changeSipUserPasswordFailure,
                  deviceRegisterAdapterActions.loadFailure,
                  deviceRegisterAdapterActions.loadPageFailure,
                  promptRegisterAdapterActions.loadFailure,
                  promptRegisterAdapterActions.loadPageFailure,
                  accountRegisterAdapterActions.loadFailure,
                  accountRegisterAdapterActions.loadPageFailure,
                  callLogsRegisterAdapterActions.loadFailure,
                  callLogsRegisterAdapterActions.loadPageFailure,
                  extensionRegisterAdapterActions.loadFailure,
                  extensionRegisterAdapterActions.loadPageFailure,
                  ExtensionDetailActions.changeSipUserPasswordFailure,
                  ExtensionPhoneRegisterActions.changeSipUserPasswordFailure,
                  accountActiveCallsRegisterAdapterActions.loadFailure,
                  accountActiveCallsRegisterAdapterActions.loadPageFailure,
                  systemActiveCallsRegisterAdapterActions.loadFailure,
                  systemActiveCallsRegisterAdapterActions.loadPageFailure,
                  accountCallHistoryRegisterAdapterActions.loadFailure,
                  accountCallHistoryRegisterAdapterActions.loadPageFailure,
                  phoneNumberRegisterAdapterActions.loadFailure,
                  phoneNumberRegisterAdapterActions.loadPageFailure,
                  mailboxRegisterAdapterActions.loadFailure,
                  mailboxRegisterAdapterActions.loadPageFailure,
                  blockedPhoneNumberRegisterAdapterActions.loadFailure,
                  blockedPhoneNumberRegisterAdapterActions.loadPageFailure,
                  presenceContactRegisterAdapterActions.loadFailure,
                  presenceContactRegisterAdapterActions.loadPageFailure,
                  logRegisterAdapterActions.loadFailure,
                  logRegisterAdapterActions.loadPageFailure,
                  ExtensionPhoneRegisterActions.extensionPhoneRegisterAdapterActions.loadFailure,
                  ExtensionPhoneRegisterActions.extensionPhoneRegisterAdapterActions.loadPageFailure,
                  LocationDetailActions.saveLocationDetailFailure,
                  LocationDetailActions.loadLocationDetailFailure,
                  submitUserPasswordResetRequestFailure,
                  userPasswordResetFailure,
                  MailboxMessageActions.clearMailboxFailure,
                  MailboxMessageActions.resetMailboxFailure,
                  MailboxMessageActions.deleteMailboxMessageDetailFailure,
                  MailboxMessageActions.saveMailboxMessageDetailFailure,
                  AccountDetailActions.editPresenceCredentialsFailure,
                  deleteCallRecordingFailure,
                  UserDetailActions.resendVerificationEmailFailure,
                  MailboxMessageActions.markUnreadMailboxMessageFailure,
                  queueHistoryActions.sendToEmptyExitRouteFailure,
                  allowIpFailure
               ),
               switchMap((error) => {
                  const errorData = processErrorMessage(error);
                  const dialogRef = this.confirmationService.confirm({
                     data: {
                        dialogType: ConfirmationDialogType.Ok,
                        header: errorData.details ?? 'Error',
                        message: errorData.userMessages.join('\n') ?? 'An Error Occurred',
                     },
                     size: DialogSize.Small,
                  });
                  return dialogRef.afterClosed();
               })
            )
         );
      },
      { dispatch: false }
   );

   constructor(private actions$: Actions, private confirmationService: ConfirmationDialogService) {}
}
